<template>
  <div style="margin-top: 113px">
    <v-container>
      <v-snackbar v-model="error" color="red darken-2">
        <b>{{ errorMessage }} </b>
      </v-snackbar>

      <v-card>
        <v-card-title>Employee Entretien Pro History </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr class="general-background">
                  <th class="text-left col-elem border-elem" style="width:15%">
                    <b>Employee</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:15%">
                    <b>Status Entretien Pro</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:10%">
                    <b>Year</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:15%">
                    <b>Strong Line Manager</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:10%">
                    <b>Action</b>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="review in reviews" v-bind:key="review.id">
                  <th class="text-left border-elem pa-0 pl-1">
                    {{ review.user.firstName }} {{ review.user.lastName }}
                  </th>
                  <th class="text-left border-elem pa-0 pl-1">
                    {{ review.status.label }}
                  </th>
                  <th class="text-left border-elem pa-0 pl-1">
                    {{ review.campaignEntretienPro.year }}
                  </th>
                  <th class="text-left border-elem pa-0 pl-1">
                    {{
                      review.manager != undefined
                        ? review.manager.firstName
                        : ""
                    }}
                    {{
                      review.manager != undefined ? review.manager.lastName : ""
                    }}
                  </th>
                  <th
                    class="text-left border-elem text-center"
                    style="width:auto !important"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          v-if="!review.campaignEntretienPro.initialization"
                          text
                          icon
                          @click="consult(review.campaignEntretienPro.year)"
                          class="btn-action"
                        >
                          <v-icon small>mdi-lead-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Show interview </span>
                    </v-tooltip>
                  </th>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<style scoped>
.btn-action:hover {
  cursor: pointer;
  color: #00695c !important;
}
</style>

<script>
export default {
  name: "employeeEntretienProHistory",
  data() {
    return {
      reviews: [],
      error: false,
      errorMessage: "",
    };
  },
  methods: {
    consult: function(year) {
      this.$store.dispatch("setCampaign", { "year": year });
      this.$router.push("/employeeEntretienPro/" + year);
    },

    loadReviews: function() {
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/entretienProHistory/", {
        method: "GET",
        credentials: "include",
      })
        .then((response) => {
          if (response.status == "200") {
            return response.json();
          }
        })
        .then((json) => {
          if (json) {
            this.reviews = json.data;
          }
        });
    },
  },
  mounted: function() {
    this.loadReviews();
  },
};
</script>
<style>
.margin-top {
  margin-top: 10px;
}

.no-margin {
  margin: 0 !important;
}

.card {
  height: 100vh !important;
}
</style>
